import { SummaryItem } from '../../../../shared/Summary/SummaryItem/SummaryItem';
import { SmallBodyText } from '../../../../../ui-toolkit';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootStore } from '../../../../../store/types';

export const VestedOwners: React.FC = () => {
  const { titleReport } = useSelector(({ order }: RootStore) => order.titleReport);

  return (
    <SummaryItem label={`Current Vested Owner(s)`} tab={'summary'}>
      {titleReport?.legalAndVesting?.vested ?? <SmallBodyText intent={`faded`}>-</SmallBodyText>}
    </SummaryItem>
  );
};
